export default __webpack_public_path__ + "media/images/brands/expmessenger/backgrounds/bg-01-ce5219f5079f291d262de623972d7bea.jpg";